import type { State } from 'src/store/types';

import {
  activityCodesAvailableHealth,
  getOrganizationId,
  getRiskAssessmentGroups,
  guidelinesNotDeleted,
  key,
} from 'src/store/selectors';
import type { AbstractPageView } from 'src/pages/abstract-page-view';
import type { PageLink } from 'src/pages/overview-page/overview-page-view-model';
import { riskLevelTemplateId } from 'src/store/selectors/templates';
import type { RiskAssessmentsPageViewModel } from '../../pages/risk-assessments-page/risk-assessments-page-view-model';
import { BASE_PATH } from '../../store';
import { pageIds } from '../../store/selectors/pages/pageIds';

export function riskAssessmentsPageView(
  hrefPrefix: string,
  viewModel: AbstractPageView,
  state: State,
): RiskAssessmentsPageViewModel {
  const o = state.organization;
  if (o === undefined) {
    throw new Error('Illegal state (E151), organization not found');
  }
  let pageLinks: PageLink[] = [];
  const riskLevelGuideline = guidelinesNotDeleted(state).find((g) => {
    return g.mainTemplateId === riskLevelTemplateId;
  });
  if (riskLevelGuideline) {
    pageLinks = [
      {
        type: 'guidelines',
        name: riskLevelGuideline.name ?? '',
        href: hrefPrefix + 'guidelines/' + riskLevelGuideline.uuid,
      },
    ];
  }

  return {
    ...viewModel,
    type: 'risk-assessments-page',
    icon: 'riskAssessments',
    href: hrefPrefix,
    substancesPageHref: '/account/' + getOrganizationId(state) + '/' + pageIds.substances,
    dataItemsPageHref: '/account/' + getOrganizationId(state) + '/' + pageIds.dataSystems,
    emergencyPageHref: '/account/' + getOrganizationId(state) + '/' + pageIds.emergency,
    availableActivityCodes: activityCodesAvailableHealth(),
    pdfHref: BASE_PATH + '/organizations/' + o.organizationId + '/overview.pdf?key=' + key(state),
    pageLinks,
    riskAssessments: getRiskAssessmentGroups(state, hrefPrefix),
  };
}
